import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "../../utils/commonComponent/delete";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import {
  moduleList,
  editAccessOptions,
} from "../../utils/commonComponent/userConstant"; // import your module & access options

// Headers for the table
const headers = ["id", "roleName", "moduleId", "access"];

// Fields for search section
const fields = [
  { value: "roleName", label: "Role Name" },
  { value: "moduleId", label: "Module ID" },
  { value: "access", label: "Access" },
];

const RBCAMasterList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rbcaList, setRbcaList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "roleName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));  


  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const handleEdit = (row) => navigate(`/master/editRBCA/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("rbac", row.id);

  // 🔹 WHERE clause builder
  const getWhereClause = () => {
    const colMap = {
      roleName: "roleName",
      moduleId: "moduleId",
      access: "access",
    };

    const colName = colMap[searchBy];
    const key = searchKey?.trim().toLowerCase();

    let whereConditions = ["status = 1"];

    if (colName && key) {
      whereConditions.push(`LOWER(${colName}) LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  // 🔹 DATA query with pagination
  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }

    return `SELECT * FROM rbac ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  // 🔹 COUNT query
  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM rbac ${whereClause};`;
  };

  // 🔹 Fetch data
  const fetchData = async () => {
    try {
      const [data, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const formattedData = data.map((item) => {
        // moduleId → labels
        const moduleNames = item.moduleId
          ? item.moduleId
              .split(",")
              .map(
                (id) => moduleList.find((m) => m.id.toString() === id)?.label
              )
              .filter(Boolean)
              .join(", ")
          : "";

        // access → labels
        const accessLabels = item.access
          ? item.access
              .split(",")
              .map(
                (id) =>
                  editAccessOptions.find((a) => a.id.toString() === id)?.label
              )
              .filter(Boolean)
              .join(", ")
          : "";

        return {
          ...item,
          roleName: item.roleName || "",
          moduleId: moduleNames,
          access: accessLabels,
        };
      });

      setRbcaList(formattedData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination total
    } catch (error) {
      console.error("Error fetching RBAC data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("roleName");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      <AddButton
        id="btn-add-rbca"
        to="/master/editRBCA/0"
        label="Add RBCA"
        icon={<AddIcon fontSize="small" />}
      />

      <ListSearchSection
        title="Search RBCA"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={rbcaList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"rbac"}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default RBCAMasterList;
